<div class="container-fluid manage-table">
    
    <div class="table-responsive">
      <table class="table table-striped table-bordered text-center">
        <tbody>
          <tr>
            <td style="vertical-align: middle;">Future Volume Growth/Degrowth</td>
            <td>
              <div style="margin-left: 25%;">
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Strength</th>
                      <th *ngIf="isFillVolumeAvailable">Fill Volume/Weight (ml or gm)</th>
                      <th>Values</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let items of strength; let i= index">
                      <td *ngIf="!show; else hide" style="width:10rem;">{{items.Strength}}</td>
                      <!-- <ng-template #hide>
                        <td><input type="text" [(ngModel)]="items.Strength"></td>
                      </ng-template> -->
                      <td *ngIf="isFillVolumeAvailable" style="width:10rem;">
                        {{items['Fill Volume/Weight (ml or gm)']}}
                      </td>
                      <!-- <td *ngIf="!showFutureFillVol; else hideFutureFillVol" style="width:10rem;">
                        {{items['Fill Volume/Weight (ml or gm)']}}</td> -->
                      <!-- <ng-template #hideFutureFillVol>
                        <td><input type="text" [(ngModel)]="items['Fill Volume/Weight (ml or gm)']"></td>
                      </ng-template> -->
                      <td  style="width:10rem;">
                        {{items.Initial_value_damp}}</td>
              
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Growth</td>
            <td>
              <div style="margin-left: 25%;">
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Strength</th>
                      <th *ngIf="isFillVolumeGrowth">Fill Volume/Weight (ml or gm)</th>
                      <th>Growth</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let items of growth; let i= index">
                      <td *ngIf="!showGrowthStrength; else hideGrowthStrength" style="width:10rem;">{{items.Strength}}
                      </td>
                      <td *ngIf="isFillVolumeGrowth" style="width:10rem;">
                        {{items['Fill Volume/Weight (ml or gm)']}}
                      </td>
                      <td  style="width:10rem;">
                        {{items.Growth}}</td>
                     
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Market Share (%)</td>
            <td>
              <div style="margin-left: 0%;">
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Strength</th>
                      <th *ngIf="isFillVolumeMarketShare">Fill Volume/Weight (ml or gm)</th>
                      <th>Launch year</th>
                      <th>Year 1</th>
                      <th>Year 2</th>
                      <th>Year 3</th>
                      <th>Final year</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of marketShare; let i = index">
                      <td *ngIf="!showMarketStrength; else hideMarketStrength" style="width:10rem;">{{ item.Strength }}
                      </td>
                      <!-- <ng-template #hideMarketStrength>
                        <td><input type="text" [(ngModel)]="item.Strength"></td>
                      </ng-template> -->
                      <!-- <td *ngIf="!showMarketFillVol; else hideMarketFillVol" style="width:10rem;">
                        {{item['Fill Volume/Weight (ml or gm)']}}</td> -->
                      <td *ngIf="isFillVolumeMarketShare" style="width:10rem;">
                        {{item['Fill Volume/Weight (ml or gm)']}}
                      </td>
                      <td  style="width:10rem;">{{
                        item['Launch year'] }}%</td>
                      
                      <td  style="width:10rem;">{{
                        item['Year 1'] }}%</td>
                    
                      <td  style="width:10rem;">{{
                        item['Year 2'] }}%</td>
                     
                      <td  style="width:10rem;">{{
                        item['Year 3'] }}%</td>
                     
                      <td  style="width:10rem;">{{
                        item['Final year'] }}%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">RLD Price Increase (%)</td>
            <td>
              <div style="margin-left: 25%;">
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Strength</th>
                      <th *ngIf="isFillVolumeRLD">Fill Volume/Weight (ml or gm)</th>
                      <th>Values</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let items of rld_price; let i= index">
                      <td>{{items.strength}}</td>
                      <td *ngIf="isFillVolumeRLD" style="width:10rem;">
                        {{items['Fill Volume/Weight (ml or gm)']}}
                      </td>
                      <td>{{items.values}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Price Erosion (%)</td>
            <td>
              <div style="margin-left: 0%;">
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Strength</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let items of priceErosion_strength?.Strength | keyvalue; let i= index">
                      <td *ngIf="!showPriceErosionStrength; else hidePriceErosionStrength" style="width:8rem;">
                        {{items.value}}</td>
                      <!-- <ng-template #hidePriceErosionStrength>
                        <td><input type="text" [(ngModel)]="items.value" style="width:10rem;" [value]="items.value"
                            [id]="'priceErosion_strength_Strength_'+i" [name]="'priceErosion_strength_Strength_'+i"></td>
                      </ng-template> -->
                    </tr>
                  </tbody>
                </table>
                <table style="float: left">
                  <thead>
                    <tr>
                      <th *ngIf="isFillVolumePriceEro">Fill Volume/Weight (ml or gm)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let items of priceErosion_fillVolume | keyvalue; let i= index">
                      <td *ngIf="!showErosionFillVol; else hideErosionFillVol" style="width: 10rem;">
                        {{items.value}}</td>
                      <ng-template #hidePriceErosionStrength>
                        <td *ngIf="isFillVolumePriceEro"><input type="text" [(ngModel)]="items.value" style="width:10rem;"
                            [value]="items.value" [id]="'priceErosion_fill_Vol_'+i" [name]="'priceErosion_fill_Vol_'+i">
                        </td>
                      </ng-template>
                    </tr>
                  </tbody>
                </table>
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Launch year</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let items of launch_year | keyvalue; let i= index">
                      <td  style="width:8rem;">
                        {{items.value}}</td>
                    
                    </tr>
                  </tbody>
                </table>
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Year 1</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let items of year_1 | keyvalue; let i= index">
                      <td  style="width:8rem;">{{items.value}}
                      </td>
                     
                    </tr>
                  </tbody>
                </table>
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Year 2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let items of year_2 | keyvalue; let i= index">
                      <td  style="width:8rem;">{{items.value}}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Year 3</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let items of year_3 | keyvalue; let i= index">
                      <td  style="width:8rem;">{{items.value}}
                      </td>
                     
                    </tr>
                  </tbody>
                </table>
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Final year</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let items of final_year | keyvalue; let i= index">
                      <td  style="width:8rem;">{{items.value}}
                      </td>
                     
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Launch Year (Market formation Date)</td>
            <td>
              <div style="margin-left: 25%;">
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Strength</th>
                      <th *ngIf="isFillVolumeLaunchYear">Fill Volume/Weight (ml or gm)</th>
                      <th>Launch Year</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let items of launch_year_market; let i= index">
                      <td *ngIf="!showMarketStrengthlaunch; else hideMarketStrengthlaunch" style="width:10rem;">{{
                        items.Strength }}</td>
                      <td *ngIf="isFillVolumeLaunchYear" style="width:10rem;">
                        {{items['Fill Volume/Weight (ml or gm)']}}
                      </td>
                      <td  style="width:10rem;">
                        {{ items.launch_year }}
                      </td>
                     
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">COGs - (API + RMPM + Overheads)</td>
            <td>
              <div style="margin-left: 0%;">
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Strength</th>
                      <th *ngIf="isFillVolumeCogs">Fill Volume/Weight (ml or gm)</th>
                      <th>API(Database)</th>
                      <th>Overhead(Box6)</th>
                      <th>RMPM(Box5)</th>
                      <th>Final Cog</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let cogs of Cogs; let i= index">
                      <td *ngIf="!showCogsStrength; else hideCogsStrength" style="width:10rem;">
                        {{cogs.Strength}}</td>
                      <!-- <ng-template #hideCogsStrength>
                        <td><input type="text" [(ngModel)]="cogs.Strength"></td>
                      </ng-template> -->
                      <!-- <td *ngIf="!showCogsFillVol; else hideCogsFillVol" style="width:10rem;">
                        {{cogs['Fill Volume/Weight (ml or gm)']}}</td> -->
                      <td >
                        {{cogs['Fill Volume/Weight (ml or gm)']}}
                      </td>
                      <td style="width:10rem;">
                        {{cogs['API(Database)']}}</td>
                      <td  style="width:10rem;">
                        {{cogs['Overhead(Box6)']}}</td>
                      <td  style="width:10rem;">
                        {{cogs['RMPM(Box5)']}}</td>
                      <td  style="width:10rem;">
                        {{cogs.Final_COG}}</td>
                     
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Therapeutic Category</td>
            <td>{{therapeuticClass}}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">API Price (USD/KG)</td>
            <td>{{apiPrice}}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Peak Year</td>
            <td>{{peakYear}}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Capex</td>
            <td>{{capex}}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Peak Sales Input</td>
            <td>{{peakSalesInput | number: '2.'}}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Peak Sales Output (10% Difference)</td>
            <td>{{peakSalesOutput | number: '2.0-0'}}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Logistics</td>
            <td>{{logistics}}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">SG&A</td>
            <td>{{sga}}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Insurance & Rebates</td>
            <td>{{Insurance}}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">WACC</td>
            <td>{{wacc}}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">Tax</td>
            <td>{{tax}}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;">No. of Expected Entrants</td>
            <td>
              <div style="margin-left: 0%;">
                <table style="float: left">
                  <thead>
                    <tr>
                      <th>Strengths</th>
                      <th>Total Approved ANDA filers</th>
                      <th>Total Tentatively approved ANDAs</th>
                      <th>Total Filed ANDA</th>
                      <th>Total Expected ANDA Entrants</th>
                      <th>All Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let entrant of expected_entrants; let i = index">
                      <td *ngIf="!showExpectedEntrance; else hideExpectedEntrance">{{
                        entrant.Strengths }}</td>
                      <td *ngIf="!showExpectedANDA; else hideExpectedANDA">{{
                        entrant['Approved ANDA filers'] }}</td>
                      <td *ngIf="!showExpectedTentative; else hideExpectedTentative">{{
                        entrant['Tentatively approved ANDAs'] }}</td>
                      <td *ngIf="!showExpectedFiled; else hideExpectedFiled">{{
                        entrant['Filed ANDA'] }}</td>
                      <td *ngIf="!showExpectedEntrants; else hideExpectedEntrants">{{
                        entrant['Expected ANDA Entrants'] }}</td>
                      <td *ngIf="!showExpectedAll; else hideExpectedAll">{{ entrant['All Total']
                        }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <div class="row mx-0 m-3 float-right">
  
    </div>
    <div class="table-responsive" style="width: 500px">
      <table class="table table-striped table-bordered text-center">
        <tr>
          <td style="background-color: #F3F8FD;">NPV</td>
          <td style="color: #17A11C; font-weight: 600;" contenteditable="true">{{npvData?.NPV | number:'1.0-0'}}</td>
        </tr>
        <tr>
          <td style="background-color: #F3F8FD;">IRR</td>
          <td style="color: #175DA1; font-weight: 600;" contenteditable="true">{{npvData?.IRR}}</td>
        </tr>
        <tr>
          <td style="background-color: #F3F8FD;">BE</td>
          <td style="color: #17A11C; font-weight: 600;" contenteditable="true">{{npvData?.BE_YEAR}}</td>
        </tr>
      </table>
    </div>
  
    <div class="p-table" *ngIf="businessCase" style="width:81rem;">
      <p-table [value]="businessCase" scrollDirection="both" [scrollable]="true">
        <ng-template pTemplate="header">
          <tr>
            <th pFrozenColumn style="width:100px; left: 0; position: sticky;z-index: 9999;"></th>
            <th *ngFor="let col of columns.header" style="width:100px;">
              {{ col }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
          <td *ngIf="rowIndex === 0" pFrozenColumn
            style="background-color: #E7EAEF;font-weight:500;text-align: -webkit-center; width: 100px; left: 0; position: sticky;z-index: 9999;">
            <tr>Revenue</tr>
            <hr />
            <tr>COGS</tr>
            <hr />
            <tr>Margin</tr>
            <hr />
            <tr>GM%</tr>
            <hr />
            <tr>OPEX</tr>
            <hr />
            <tr>EBITDA</tr>
            <hr />
            <tr>D&A</tr>
            <hr />
            <tr>PBT</tr>
            <hr />
            <tr>Net Tax</tr>
            <hr />
            <tr>PAT</tr>
          </td>
          <td style="text-align: -webkit-center; width:100px;">
            <tr>{{rowData.Revenue}}</tr>
            <hr />
            <tr>{{rowData.COGs}}</tr>
            <hr />
            <tr>{{rowData.Margin}}</tr>
            <hr />
            <tr>{{rowData.GM}}</tr>
            <hr />
            <tr>{{rowData.OPEX}}</tr>
            <hr />
            <tr>{{rowData.EBITDA}}</tr>
            <hr />
            <tr>{{rowData.DandA}}</tr>
            <hr />
            <tr>{{rowData.PBT}}</tr>
            <hr />
            <tr>{{rowData.NetTax}}</tr>
            <hr />
            <tr>{{rowData.PAT}}</tr>
          </td>
        </ng-template>
      </p-table>
    </div>
    <div class="p-table " *ngIf="zeroBusinessData">
      <p-table scrollDirection="both" [scrollable]="true" [value]="zeroBusinessData.data">
        <ng-template pTemplate="header">
          <tr>
            <th pFrozenColumn style="width:100px; left: 0; position: sticky;z-index: 9999;"></th>
            <th *ngFor="let col of columns?.header">
              {{ col }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
          <td *ngIf="rowIndex === 0"
            style="background-color: #E7EAEF;font-weight:500;text-align: -webkit-center; width: 100px; left: 0; position: sticky;z-index: 9999;">
            <tr pFrozenColumn>Revenue</tr>
            <hr />
            <tr>COGS</tr>
            <hr />
            <tr>Margin</tr>
            <hr />
            <tr>GM%</tr>
            <hr />
            <tr>OPEX</tr>
            <hr />
            <tr>EBITDA</tr>
            <hr />
            <tr>D&A</tr>
            <hr />
            <tr>PBT</tr>
            <hr />
            <tr>Net Tax</tr>
            <hr />
            <tr>PAT</tr>
          </td>
          <td style="text-align: -webkit-center;">
            <tr>{{rowData.Revenue}}</tr>
            <hr />
            <tr>{{rowData.COGs}}</tr>
            <hr />
            <tr>{{rowData.Margin}}</tr>
            <hr />
            <tr>{{rowData.GM}}</tr>
            <hr />
            <tr>{{rowData.OPEX}}</tr>
            <hr />
            <tr>{{rowData.EBITDA}}</tr>
            <hr />
            <tr>{{rowData.DandA}}</tr>
            <hr />
            <tr>{{rowData.PBT}}</tr>
            <hr />
            <tr>{{rowData.NetTax}}</tr>
            <hr />
            <tr>{{rowData.PAT}}</tr>
          </td>
        </ng-template>
      </p-table>
    </div>
  </div>